import { type SkeletonProps } from '~/components/component-library/Skeleton/types'
import { cn } from '~/utils/tailwind-utils'

export { type SkeletonProps } from '~/components/component-library/Skeleton/types'

const sizes = {
  xs: 3,
  sm: 4,
  md: 8,
  lg: 16,
}

export const Skeleton = ({
  length,
  height,
  size = 'md',
  circle = false,
  className = '',
}: SkeletonProps) => {
  return circle ? (
    <div
      className={cn(
        `inline-block rounded-full bg-gray-200 dark:bg-gray-800 w-${sizes[size]} h-${sizes[size]}`,
        className,
      )}
    />
  ) : (
    <div
      className={cn(
        `h-${sizes[size]} w-full animate-pulse rounded-lg bg-gray-200 dark:bg-gray-800`,
        className,
      )}
      style={{
        ...(length && { width: `${length}rem` }),
        ...(height && { height: `${height}rem` }),
      }}
    />
  )
}
